<script setup lang="ts">
import { defineProps } from "vue";
import { MiddlePoint } from "@/types/stage";

const props = defineProps<{
  middlePoint: MiddlePoint | null;
}>();
</script>

<template>
  <v-circle
    v-if="props.middlePoint"
    :config="{
      x: props.middlePoint.x,
      y: props.middlePoint.y,
      radius: 10,
      fill: 'orange',
      draggable: true,
    }"
  />
</template>
